const QUERY_FREE_PURCHASE_TYPE = `
  query {
    free_purchase_type{
      abort_part_one
      abort_part_one_image_url
      abort_part_two
      abort_part_two_image_url
      clothing_slot_count
      accessory_slot_count
      play_description_text
    }
  }
`

const MUTATION_INVITE_TOTE_FREE_PURCHASE = `
  mutation InviteToteFreePurchase($input: InviteToteFreePurchaseInput!) {
    InviteToteFreePurchase(input: $input) {
      success
      errors
    }
  }
`
export { QUERY_FREE_PURCHASE_TYPE, MUTATION_INVITE_TOTE_FREE_PURCHASE }
